import type { WrongAppInfo } from '../../../lib/deploySurface';
import { getDeploySurface, SURFACE_APP_TITLE } from '../../../lib/deploySurface';

type WrongAppScreenProps = {
  info: WrongAppInfo;
  onSignOut?: () => void;
};

export default function WrongAppScreen({ info, onSignOut }: WrongAppScreenProps) {
  const surface = getDeploySurface();
  const currentTitle =
    surface !== 'website' && surface in SURFACE_APP_TITLE
      ? SURFACE_APP_TITLE[surface as keyof typeof SURFACE_APP_TITLE]
      : 'This app';

  return (
    <main className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 gap-6">
      <div className="max-w-md space-y-3">
        <p className="text-xs uppercase tracking-[0.35em] text-white/50">Wrong app</p>
        <h1 className="text-2xl font-black text-white">Use {info.appLabel}</h1>
        <p className="text-sm text-white/70 leading-relaxed">{info.hint}</p>
        <p className="text-xs text-white/50">
          You signed in on <span className="text-white/80">{currentTitle}</span>, which does not include that
          experience.
        </p>
      </div>
      {info.webUrl ? (
        <a
          href={info.webUrl}
          className="inline-flex items-center justify-center rounded-xl bg-ninpo-lime px-6 py-3 text-sm font-bold text-ninpo-black"
          rel="noopener noreferrer"
        >
          Open {info.appLabel}
        </a>
      ) : null}
      {onSignOut ? (
        <button
          type="button"
          onClick={onSignOut}
          className="text-xs uppercase tracking-widest text-white/60 hover:text-white"
        >
          Sign out
        </button>
      ) : null}
    </main>
  );
}
